export enum FastPaymentsEnum {
  APPLE_PAY = "APPLE_PAY",
}
